import styled from 'styled-components';

export const FreeZoneColumnSection = styled.div`
  display: flex;
  padding: 0;

  @media (max-width: 575.98px) {
    display: inherit;
  }
`;

export const BoxOne = styled.div`
  background-color: #ebebeb;
  padding: 10vh 0;
  width: 50%;

  @media (max-width: 991.98px) {
    padding: 50px 30px;
  }

  @media (max-width: 575.98px) {
    width: 100%;
    padding: 50px;
  }
`;

export const BoxField = styled.div`
  padding-right: 0 !important;
  word-wrap: break-word;
`;

export const ArticleContent = styled.article`
  max-width: 375px;
  margin: 0 auto;
  position: relative;
  z-index: 2;

  @media (max-width: 575.98px) {
    width: 100%;
  }

  h2 {
    color: #000 !important;

    @media (max-width: 1199.98px) {
      font-size: 26px;
      line-height: 30px;
    }

    @media (max-width: 767.98px) {
      font-size: 30px;
      margin-bottom: 1rem;
      line-height: 60px;
    }
  }

  p {
    margin-bottom: 1.5rem !important;
    line-height: inherit;
    margin: 0 0 10px;
  }
`;

export const BoxTwo = styled.div`
  background-color: #f7f7f7;
  padding: 10vh 0;
  width: 50%;

  @media (max-width: 991.98px) {
    padding: 50px 30px;
  }

  @media (max-width: 575.98px) {
    width: 100%;
    padding: 50px;
  }
`;
